import { useEffect, useRef, useState } from "react";

export const useEscapeKey = (onEscape: () => void) => {
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onEscape();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    
    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [onEscape]);
};


export const useOutsideClick = (
  ref: React.RefObject<HTMLElement>,
  callback: (el: Node) => void
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      console.log("click outside", ref?.current?.contains(event.target as Node));

      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event.target as Node);
      }
    };

    document.addEventListener("mouseup", handleClickOutside);

    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [ref, callback]);
};


export  const useClickedOutsideMany = (
  refs: React.RefObject<HTMLElement>[],
  callback: (el: Node) => void
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const isOutside = refs.every((ref) => {
        return ref.current && !ref.current.contains(event.target as Node);
      });

      if (isOutside) {
        callback(event.target as Node);
      }
    };

    document.addEventListener("mouseup", handleClickOutside);

    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [refs, callback]);
}


export const useClickOutside = (
  ref: React.RefObject<HTMLElement>,
  onClickOutside: ( el : HTMLElement) => void
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
  
      if (ref.current && ref.current instanceof HTMLElement && !ref.current.contains(event.target as Node)) {
        onClickOutside(event.target as HTMLElement);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onClickOutside]);
};


export const useScrollOutside = (
  ref: React.RefObject<HTMLElement>,
  onScrollOutside: (el: HTMLElement) => void
) => {
  useEffect(() => {
    const handleScrollOutside = (event: Event) => {
      console.log("scroll outside", ref?.current?.contains(event.target as Node));
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onScrollOutside(event.target as HTMLElement);
      }
    }; 

    window.addEventListener("scroll", handleScrollOutside, true);

    return () => {
      window.removeEventListener("scroll", handleScrollOutside, true);
    };
  }, [ref, onScrollOutside]);
};


export const useOnScroll = (
  onScrollOutside: (el: HTMLElement) => void
) => {
  useEffect(() => {
    const handleScrollOutside = (event: Event) => {
 
        onScrollOutside(event.target as HTMLElement);
    };

    window.addEventListener("scroll", handleScrollOutside, true);

    return () => {
      window.removeEventListener("scroll", handleScrollOutside, true);
    };
  }, [ onScrollOutside]);
};

export const useMouseRollOutSide = (
  ref: React.RefObject<HTMLElement>,
  onScrollOutside: (el: HTMLElement) => void
) => {
  useEffect(() => {


    const handleWheelOutside = (event: WheelEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onScrollOutside(ref.current);
      }
    };

    document.addEventListener("wheel", handleWheelOutside);

    return () => {
      document.removeEventListener("wheel", handleWheelOutside);
    };
  }, [ref, onScrollOutside]);
};

export const usePageHeight = () => {
  const [pageHeight, setPageHeight] = useState(window.innerHeight);

  useEffect(() => {
    const updateHeight = () => setPageHeight(window.innerHeight);

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return pageHeight;
};